<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col v-if="agent" cols="2" align="start" style="align-content: center;">
                <div>
                    <v-img
                        :src="this.$store.getters.getClientImage"
                        class="bot-image ml-auto"
                        :aspect-ratio="16/9"
                        positison="bottom"
                        contain
                    />
                </div>
            </v-col>
            <v-col align="center">
                <v-carousel
                    hide-delimiters
                    height="430"
                >
                    <v-carousel-item
                        v-for="(element, index) in reply.message.attachment.payload.elements"
                        :key="index"
                    >
                        <v-card
                            class="white--text rounded-xl"
                            color="grey lighten-5"
                            max-width="300px"
                        >           
                            <v-img
                                max-width="350px"
                                max-height="350px"
                                contain
                                :src="element.image_url"
                            />
                            <v-card-title class="black--text py-0 pl-2">
                                {{ element.title }}
                            </v-card-title>
                            <v-card-text class="black--text text-subtitle-1 text-left pl-3">
                                {{ element.subtitle }}
                            </v-card-text>
                            <v-card-actions>
                                <v-row no-gutters>
                                    <v-col
                                        cols="12"
                                        align="center"
                                        v-for="(button, index) in element.buttons"
                                        :key="index"
                                        class="py-1"
                                    >
                                        <v-btn
                                            :color="mainColor"
                                            class="text-subtitle-1 font-weight-bold"
                                            text
                                            @click="clickButton(button)"
                                        >
                                            {{ button.title }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-actions>
                        </v-card>
                    </v-carousel-item>
                </v-carousel>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            agent: {
                type: Boolean,
                default: false
            },
            reply: {
                type: Object,
            },
            mainColor: {
                type: String,
                default: null
            }
        },
        data: () => ({
        }),
        methods: {
            clickButton(button) {
                if (button.url) {
                    window.open(button.url, '_blank', 'noreferrer');
                } else {
                    this.$emit('prepareMessage', button.payload)
                }
            }
        }
    }
</script>

<style scoped src="../../../node_modules/vuetify/dist/vuetify.min.css">
</style>

<style scoped src="@mdi/font/css/materialdesignicons.css">
</style>

<style>
.bot-image {
    border-radius: 50%;
}
</style>